import { useCommonServices } from '../../../../lib/hooks'
import { type BrowserService } from '../../../../lib/services/browser'

export enum MailInstallType {
  Chrome = 'chrome',
  MacOS = 'macOS',
  Windows = 'windows',
}

function isEligibleForInstall(install: MailInstallType, browserService: BrowserService): boolean {
  return installEligibilityMap[install](browserService)
}

const installEligibilityMap: Record<MailInstallType, (browserService: BrowserService) => boolean> =
  {
    [MailInstallType.Chrome]: bs => bs.isChrome && !bs.isMobileAndroidOrIOS,
    [MailInstallType.MacOS]: bs => bs.isMac && !bs.isMobileAndroidOrIOS,
    [MailInstallType.Windows]: bs => bs.isWindows && !bs.isMobileAndroidOrIOS,
  }

export const mailInstallTypes = [
  MailInstallType.Chrome,
  MailInstallType.MacOS,
  MailInstallType.Windows,
]

export function useIsEligibleForExtension(): boolean {
  const { browserService } = useCommonServices()
  return isEligibleForInstall(MailInstallType.Chrome, browserService)
}

export function useIsEligibleForDownload(): boolean {
  const { browserService } = useCommonServices()
  return (
    isEligibleForInstall(MailInstallType.MacOS, browserService) ||
    isEligibleForInstall(MailInstallType.Windows, browserService)
  )
}
